/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OrgNoteCreate,
  OrgNoteDelete,
  OrgNoteOnAzure,
  OrgNoteUpdate,
} from '../models/index';
import {
    OrgNoteCreateFromJSON,
    OrgNoteCreateToJSON,
    OrgNoteDeleteFromJSON,
    OrgNoteDeleteToJSON,
    OrgNoteOnAzureFromJSON,
    OrgNoteOnAzureToJSON,
    OrgNoteUpdateFromJSON,
    OrgNoteUpdateToJSON,
} from '../models/index';

export interface ApiOrgNoteAddPostRequest {
    orgNoteCreate?: OrgNoteCreate;
}

export interface ApiOrgNoteDeleteDeleteRequest {
    orgNoteDelete?: OrgNoteDelete;
}

export interface ApiOrgNoteGetAllByOrgCodeGetRequest {
    orgCode?: string;
}

export interface ApiOrgNoteUpdatePutRequest {
    orgNoteUpdate?: OrgNoteUpdate;
}

/**
 * 
 */
export class OrgNoteApi extends runtime.BaseAPI {

    /**
     */
    async apiOrgNoteAddPostRaw(requestParameters: ApiOrgNoteAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgNoteOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgNote/Add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrgNoteCreateToJSON(requestParameters['orgNoteCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgNoteOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrgNoteAddPost(requestParameters: ApiOrgNoteAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgNoteOnAzure> {
        const response = await this.apiOrgNoteAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgNoteDeleteDeleteRaw(requestParameters: ApiOrgNoteDeleteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgNote/Delete`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: OrgNoteDeleteToJSON(requestParameters['orgNoteDelete']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrgNoteDeleteDelete(requestParameters: ApiOrgNoteDeleteDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrgNoteDeleteDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrgNoteGetAllByOrgCodeGetRaw(requestParameters: ApiOrgNoteGetAllByOrgCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrgNoteOnAzure>>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgNote/GetAllByOrgCode`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrgNoteOnAzureFromJSON));
    }

    /**
     */
    async apiOrgNoteGetAllByOrgCodeGet(requestParameters: ApiOrgNoteGetAllByOrgCodeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrgNoteOnAzure>> {
        const response = await this.apiOrgNoteGetAllByOrgCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrgNoteUpdatePutRaw(requestParameters: ApiOrgNoteUpdatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/OrgNote/Update`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgNoteUpdateToJSON(requestParameters['orgNoteUpdate']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrgNoteUpdatePut(requestParameters: ApiOrgNoteUpdatePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrgNoteUpdatePutRaw(requestParameters, initOverrides);
    }

}
